import { ForbiddenError, NetworkError, UnauthorizedError } from "@exceptions";

export function throwQueryErrorToBoundary(error: Error): boolean {
  return !(
    error instanceof ForbiddenError ||
    error instanceof UnauthorizedError ||
    error instanceof NetworkError
  );
}
